import { Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { FC, useEffect, useMemo, useState } from "react";
import { deleteUserById, User } from "src/apis/user";
import NoDataAlert from "src/pages/components/NoDataAlert";
import TableActionsCell from "src/pages/components/TableActionsCell";
import { isUserAdministrator } from "src/utils/auth";
import { Id } from "src/utils/types";

type UserTableProps = {
  users: User[],
}

const UserTable: FC<UserTableProps> = ({ users }): JSX.Element => {
  const hasUsers = useMemo(() => Boolean(users) && users.length > 0, [users]);
  const [entries, setEntries] = useState(users);

  const removeEntry = (entryId: Id) => {
    const newEntries = entries?.filter((e) => e.id !== entryId);

    setEntries(newEntries)
  }

  useEffect(() => {
    if (hasUsers) {
      setEntries(users)
    }
  }, [hasUsers, users])

  return hasUsers ? (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell><strong>ID</strong></TableCell>
            <TableCell><strong>Nome</strong></TableCell>
            <TableCell><strong>Email</strong></TableCell>
            <TableCell><strong>Tipo</strong></TableCell>
            <TableCell><strong>Empresa</strong></TableCell>
            {isUserAdministrator() && (
              <TableCell><strong>Ações</strong></TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {entries?.map((user: User) => (
            <TableRow>
              <TableCell>{user.id}</TableCell>
              <TableCell>{user.name}</TableCell>
              <TableCell>{user.email}</TableCell>
              <TableCell><Chip label={user.type} /></TableCell>
              <TableCell>{user.company}</TableCell>
              {isUserAdministrator() && (
                <TableActionsCell
                  editUrl={`/usuario/${user.id}/editar`}
                  deleteCallback={async () => {
                    if (window.confirm(`Deseja mesmo deletar esse usuário (ID ${user?.id})? Essa ação não poderá ser desfeita e irá apagar todos os registros relacionados com o usuário, como ações e atendimentos realizados`)) {
                      await deleteUserById(user.id);

                      removeEntry(user?.id);
                    }
                  }}
                />
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <NoDataAlert />
  )
}

export default UserTable;
